import { KeyboardAvoidingView as NbKeyboardAvoidingView } from '@fhs-legacy/native-base';

import { addWithConfig } from '../../utils';

export const KeyboardAvoidingView = NbKeyboardAvoidingView;

export default addWithConfig(KeyboardAvoidingView);
